<template>
  <div>
    <!-- เงื่อนไขในการสั่งซื้อสินค้า -->
    <b-card no-body >
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h3 v-if="this.checkOrderType == 1">
          <feather-icon icon="StarIcon"/>
          ประเภทใบสั่งซื้อ : แบบปลีก
        </h3>
        <h3 v-if="this.checkOrderType == 2">
          <feather-icon icon="StarIcon"/>
          ประเภทใบสั่งซื้อ : แบบกิโล
        </h3>
      </b-card-header>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          เงื่อนไขในการสั่งซื้อสินค้า
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary" >
        <b-row class="pl-2 pt-1" v-for="info in orders.agreementResponses" :key="info.orderNo" id="accept">
          <b-col cols="0">{{info.orderNo}}.</b-col>
          <b-col cols="11" class="h5">{{info.description}}</b-col>
        </b-row>
        <b-row class="pl-2 pt-2">
          <b-col cols="0"/>
          <b-col cols="12" >
            <b-form-checkbox
              v-model="accept"
              :value="true"
              :unchecked-value="false"
            >
              <p>
                ตกลงและยอมรับเงื่อนไข
                <span v-if="this.valCondition == false" class="textVal">
                  กรุณายอมรับเงื่อนไขการสั่งซื้อ
                </span>
              </p>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- รูปแบบการนำเข้า -->
    <b-card no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          กรุณาเลือกรูปแบบการนำเข้า
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <b-form-group class="pt-2">
          <b-form-radio-group
            v-model="shipType"
            :options="shipTypeOptions"
            value-field="id"
            text-field="descriptionTH"
            name="radio-validation"
          >
          </b-form-radio-group>
        </b-form-group>
      </b-card-body>
    </b-card>

    <!-- ที่อยู่จัดส่ง -->
    <!-- v-if="this.checkOrderType == 1" -->
    <b-card no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          กรุณาเลือกที่อยู่จัดส่ง
          <b-button
            class="my-n1"
            variant="primary"
            size="sm"
            v-b-modal.customer-address
            @click="getPostcode()"
          >
            เพิ่มที่อยู่ใหม่
          </b-button>
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <b-form-group class="pt-2" >
          <b-form-radio-group
            v-model="selCusAddress"
            stacked
          >
            <div v-for="item in cusAddress" :key="item.length" class="pb-1">
              <b-form-radio :value="item.addressID">
                {{item.name}} โทร.{{item.phone}} {{item.address}} ต.{{item.tambon}} อ.{{item.amphoe}} จ.{{item.province}} {{item.postcode}}
              </b-form-radio>
            </div>
          </b-form-radio-group>
        </b-form-group>

        <!-- v-if="this.checkOrderType == 1" -->
        <b-row class="pl-1">
          <b-form-checkbox
            v-model="checkSender"
            :value="true"
            :unchecked-value="false"
          >
            ต้องการส่งในนาม
          </b-form-checkbox>
          <b-button
            class="ml-1"
            variant="primary"
            size="sm"
            v-b-modal.sender-address
            @click="getPostcode()"
          >
            เพิ่มผู้ส่งในนาม
          </b-button>
        </b-row>

        <b-form-group v-if="checkSender == true">
          <b-form-radio-group
            v-model="selSenderAddress"
            stacked
          >
            <div v-for="item in senderAddress" :key="item.length" class="pt-1">
              <b-form-radio  :value="item.addressID">
                {{item.name}} โทร.{{item.phone}} {{item.address}} ต.{{item.tambon}} อ.{{item.amphoe}} จ.{{item.province}} {{item.postcode}}
              </b-form-radio>
            </div>
          </b-form-radio-group>
        </b-form-group>
      </b-card-body>
    </b-card>

    <!-- รูปแบบการส่ง -->
    <!-- v-if="this.checkOrderType == 1" -->
    <b-card no-body id="express">
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          กรุณาเลือกรูปแบบการส่ง
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <b-form-group class="pt-2">
          <span v-if="this.valExpress == false" class="textVal">กรุณาเลือกรูปแบบการส่ง</span>
          <b-form-radio-group
            v-model="express"
            stacked
          >
            <div v-for="item in orders.domesticTypes" :key="item.length" class="pb-1">
              <b-form-radio v-if="item.rowId == 12" :value="item.rowId">
                ส่งเข้าคลัง PACKHAI Fulfillment บริการ เก็บ แพ็ค ส่ง ครบวงจร สอบถามรายละเอียดเพิ่มเติม <b-link href="https://lin.ee/fbDRpjC" target="_blank">https://lin.ee/fbDRpjC</b-link>
              </b-form-radio>
              <b-form-radio v-else :value="item.rowId">
                {{item.description}}
              </b-form-radio>
            </div>
          </b-form-radio-group>
          <b-form-textarea
            v-model="otherExpress"
            v-if="this.express == 11"
            class="col-6 ml-2"
            placeholder="โปรดระบุ"
          >
          </b-form-textarea>
        </b-form-group>
      </b-card-body>
    </b-card>

    <!-- หมายเหตุ -->
    <b-card no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          หมายเหตุ
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <b-form-group class="pt-2">
          <b-form-textarea v-model="remark" class="col-md-6" placeholder="ข้อความที่ต้องการฝากถึงร้าน"/>
        </b-form-group>
      </b-card-body>
    </b-card>

    <!-- รายการสินค้า -->
    <b-card no-body>
      <b-card-header header-bg-variant="light" header-border-variant="secondary">
        <h4>
          <feather-icon icon="StarIcon"/>
          รายการสินค้า
        </h4>
      </b-card-header>
      <b-card-body body-border-variant="secondary">
        <!-- pc -->
        <b-form-group v-for="order, index in orders.cartProducts" :key="index" class="pt-2 d-none d-sm-block">
          ร้านค้า : {{order.shopName}}
          <b-table
            responsive
            class="position-relative"
            :items="order.cartProductItems"
            :fields="orderTable"
            outlined="outlined"
            table-class="table-sm-responsive text-nowrap"
          >
            <template #cell(photoLink)="data">
              <b-img
                :src="data.value"
                width="70px"
                class="cursor-pointer"
                @click="showImg(data.value)"
              />
            </template>
            <template #cell(productLink)="data">
              <b-link v-for="title in order.cartProductItems" :key="title.length" :href="data.value" target="_blank">
                {{title.title}}
              </b-link>
            </template>
            <template #cell(price)="data">
              {{format_price(data.value)}}
            </template>
            <template #cell(total)="data">
              {{format_price(data.value)}}
            </template>
          </b-table>
          <div v-for="item in makeBoxList" :key="item.length">
            <div v-if="item.shopName == order.shopName">
              <span v-if="item.isMakeBox == true" class="h4">แพ็คแบบ: ตีลังไม้</span>
              <span v-else class="h4">แพ็คแบบ: ธรรมดา</span>
            </div>
          </div>
        </b-form-group>

        <!-- mobile -->
        <b-form-group v-for="order in orders.cartProducts" :key="order.length" class="pt-2 d-block d-sm-none">
          ร้านค้า : {{order.shopName}}
          <b-card v-for="subOrder in order.cartProductItems" :key="subOrder.length" class="mb-n1">
            <b-row>
              <b-col cols="3" class="px-0">
                <b-img
                  :src="subOrder.photoLink"
                  width="70px"
                  height="70px"
                  @click="showImg(subOrder.photoLink)"
                />
              </b-col>
              <b-col class="pr-0">
                <b-link :href="subOrder.productLink">
                  {{subOrder.title}}
                </b-link>
                <div v-if="subOrder.prop1Text">{{subOrder.prop1Text}} : {{subOrder.prop1Value}}</div>
                <div v-if="subOrder.prop2Text">{{subOrder.prop2Text}} : {{subOrder.prop2Value}}</div>
                <div v-if="subOrder.remarkCustomer" class="text-right">{{subOrder.remarkCustomer}}</div>
                <b-row>
                  <b-col class="pr-0">
                    Ұ {{format_price(subOrder.price)}}
                  </b-col>
                  <b-col class="px-0">
                    x {{subOrder.quantity}}
                  </b-col>
                  <b-col class="px-0">
                    = {{format_price(format_price(subOrder.price) * subOrder.quantity)}}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
          </b-card>
        </b-form-group>

        <b-row class="justify-content-end">
          <b-col class="text-right col-md-3 col-6">
            <div>จำนวน</div>
          </b-col>
          <b-col class="text-right col-md-2">
            <div>{{this.toatalQuantity}}</div>
          </b-col>
          <b-col class="col-md-1">
            <div>ชิ้น</div>
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col class="text-right col-md-3 col-6">
            <div>ราคาสินค้า(หยวน)</div>
          </b-col>
          <b-col class="text-right col-md-2">
            <div>{{format_price(this.totalYuan)}}</div>
          </b-col>
          <b-col class="col-md-1">
            <div>หยวน</div>
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col class="text-right col-md-3 col-6">
            <div>เรท</div>
          </b-col>
          <b-col class="text-right col-md-2">
            <div>{{this.orders.sellRate}}</div>
          </b-col>
          <b-col class="col-md-1">
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col class="text-right col-md-3 col-6">
            <div>ราคาสินค้า(บาท)</div>
          </b-col>
          <b-col class="text-right col-md-2">
            <div>{{format_price(this.totalYuan * this.orders.sellRate)}}</div>
          </b-col>
          <b-col class="col-md-1">
            <div >บาท</div>
          </b-col>
        </b-row>
        <b-button
          class="float-right mt-1 col-md-2"
          variant="primary"
          @click="btnSendOrder()"
          :disabled="this.loadButton == false"
        >
          <b-spinner v-if="this.loadButton == false" small />
          สั่งสินค้า
        </b-button>
      </b-card-body>
    </b-card>

    <!-- dialog ที่อยู่จัดส่ง-->
    <b-modal
      id="customer-address"
      ref="customer-address"
      cancel-variant="outline-secondary"
      ok-title="บันทึกที่อยู่"
      @ok="addCustomerAddress()"
      cancel-title="ยกเลิก"
      centered
      title="เพิ่มที่อยู่ผู้รับ"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group>
          <label >ชื่อผู้รับ :</label>
          <b-form-input v-model="nameAddress"/>
          <span class="float-right textVal" v-if="this.valName == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >เบอร์โทร :</label>
          <b-form-input v-model="telAddress"/>
          <span class="float-right textVal" v-if="this.valTel == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >ที่อยู่ :</label>
          <b-form-Textarea v-model="address"/>
          <span class="float-right textVal" v-if="this.valAddress == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :</label>
          <v-select
            v-model="selCustomerPostcode"
            :options="postcodeMapping"
            label="list"
          >
          </v-select>
        </b-form-group>
        <b-form-checkbox
          v-model="defaultAddress"
          :value="true"
          :unchecked-value="false"
        >
          ใช้เป็นที่อยู่จัดส่งหลัก
        </b-form-checkbox>
      </b-form>
    </b-modal>

    <!-- dialog ที่อยู่ผู้ส่ง-->
    <b-modal
      id="sender-address"
      ref="sender-address"
      cancel-variant="outline-secondary"
      ok-title="บันทึกที่อยู่"
      @ok="addSenderAddress()"
      cancel-title="ยกเลิก"
      centered
      title="เพิ่มที่อยู่ในนาม"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group>
          <label >ส่งในนาม :</label>
          <b-form-input v-model="nameAddress"/>
          <span class="float-right textVal" v-if="this.valName == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >เบอร์โทร :</label>
          <b-form-input v-model="telAddress"/>
          <span class="float-right textVal" v-if="this.valTel == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >ที่อยู่ :</label>
          <b-form-Textarea v-model="address"/>
          <span class="float-right textVal" v-if="this.valAddress == false">กรุณาระบุ</span>
        </b-form-group>
        <b-form-group>
          <label >รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :</label>
          <v-select
            v-model="selSenderPostcode"
            :options="postcodeMapping"
            label="list"
          >
          </v-select>
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- show img -->
    <b-modal ref="show-img" size="lg" hide-footer centered>
      <b-img class="px-0" :src="this.imgLink" fluid ></b-img>
    </b-modal>

  </div>
</template>

<script>
import {
  BForm, BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
  BRow, BCol, BFormGroup, BFormInput, BButton, BFormInvalidFeedback,
  BFormCheckbox, BFormRadioGroup, BFormRadio, BFormTextarea, BTable,
  BImg, BLink, BModal, VBModal, BFormSelect, BFormSelectOption, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required, integer } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
import { format_price } from '@/views/global_function.js'

export default {
  components: {
    // BSV
    BForm, BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
    BRow, BCol, BFormGroup, BFormInput, BButton, BFormInvalidFeedback,
    BFormCheckbox, BFormRadioGroup, BFormRadio, BFormTextarea, BTable,
    BImg, BLink, BModal, VBModal, BFormSelect, BFormSelectOption, BSpinner,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    // 3rd party
    vSelect,
  },

  directives: {
    'b-modal': VBModal,
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      checkOrderType: null,
      accept: false,
      shipType: JSON.parse(localStorage.getItem('ship_type')),
      shipTypeOptions: [],
      orderTable: [
        { key: 'photoLink', label: 'รูป', thClass: 'text-center', tdClass: 'text-center',} ,
        { key: 'productLink', label: 'ลิงค์สินค้า', tdClass: 'align-text-top',},
        { key: 'prop1Text', label: 'สี/ไซส์', thClass: 'text-center', tdClass: 'align-text-top text-center'},
        { key: 'price', label: 'ราคา/ชิ้น', thClass: 'text-center', tdClass: 'align-text-top text-right'},
        { key: 'quantity', label: 'จำนวน', thClass: 'text-center', tdClass: 'align-text-top text-right'},
        { key: 'total', label: 'รวมราคา', thClass: 'text-center', tdClass: 'align-text-top text-right'},
        { key: 'remarkCustomer', label: 'หมายเหตุ', tdClass: 'align-text-top'},
      ],
      expressList: [
        { value: 1, text: 'Best Express (ส่งทั่วไทย ราคาถูก)' },
        { value: 2, text: 'พัสดุไปรษณีย์' },
        { value: 3, text: 'ลงทะเบียนไปรษณีย์' },
        { value: 4, text: 'EMS' },
        { value: 5, text: 'ขนส่งเอกชน นิ่มซี่เส็ง' },
        { value: 6, text: 'ขนส่งเอกชน Kerry' },
        { value: 7, text: 'ขนส่ง Taobao2you (กรุงเทพ สมุทปราการ นนทบุรี ปทุมธานี)' },
        { value: 8, text: 'ให้ทางร้านเลือกอันที่ถูกและเร็ว' },
        { value: 9, text: 'รับสินค้าเอง' },
        { value: 10, text: 'อื่่นๆ โปรดระบุ' },
      ],
      express: '',
      expressSend: '',
      otherExpress: '',
      selCusAddress: null,
      selSenderAddress: 0,
      cusAddress: [],
      senderAddress: [],
      checkSender: false,
      remark: '',
      orders: [],
      toatalQuantity: '',
      totalYuan: 0,

      nameAddress: '',
      telAddress: '',
      address: '',
      postcodeMapping: [],
      selCustomerPostcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'},
      selSenderPostcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--'},
      defaultAddress: false,
      valName: true,
      valTel: true,
      valAddress: true,

      valCondition: true,
      valExpress: true,

      makeBoxList: [],
      imgLink: '',
      loadButton: true
    };
  },
  async created() {
    this.getOrders()
    this.getCusAddress()
    this.getSenderAddress()
    this.summary()
    this.getTransportType()
    this.makeBoxList = JSON.parse(localStorage.getItem('makeBox_list'))
  },
  watch: {
    express(){
      this.orders.domesticTypes.forEach((e) => {
        if (e.rowId == this.express) {
          this.expressSend = e
        }
      })
    },
  },
  setup(_, { emit }) {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(() => {})

    const onSubmit = () => {
      emit('next-step')
    }

    return {
      // Form
      onSubmit,

      // Form Validation
      refFormObserver,
      getValidationState,
      resetForm,

      // FOrm Validators
      required,
      integer,
    }
  },
  methods: {
    format_price,
    async getOrders(){
      var keepdata = []
      var list = await JSON.parse(localStorage.getItem('list_item'))
      this.checkOrderType = await JSON.parse(localStorage.getItem('order_type'))

      var axios = require('axios');
      var data = JSON.stringify({
        // "customerID": 1,
        "customerID": JSON.parse(localStorage.getItem('cusId')),
        "itemIDList": list,
        "orderType": this.checkOrderType
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Cart/load-send-order-page',
        // url: 'https://localhost:44345/app/Cart/load-send-order-page',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.orders = keepdata
    },
    async getTransportType() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/order/get-transport-type',
        { headers: header_token }
      );
      this.shipTypeOptions = response.data
    },
    async getCusAddress(){
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-customer-address',
        {
          // 'customerID': 1,
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      this.cusAddress = response.data
      this.selCusAddress = response.data[0].addressID
    },

    async getSenderAddress(){
      let response = await axios.post(
        taobaoService_dotnet + 'app/Customer/get-sender-address',
        {
          // 'customerID': 1,
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      this.senderAddress = response.data
      this.selSenderAddress = response.data[0].addressID
    },

    async summary(){
      this.toatalQuantity = JSON.parse(localStorage.getItem('total_quantity'))
      this.totalYuan = JSON.parse(localStorage.getItem('total_yuan'))
    },

    async getPostcode(){
      this.postcodeMapping = await JSON.parse(localStorage.getItem('postcode'))
      if (this.postcodeMapping == []) {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,

            }
          )
        })
      }
    },

    async btnSendOrder(){
      if ( this.accept == false ) {
        this.valCondition = false
        document.getElementById('accept').scrollIntoView();
      } else if ( this.express == '' ) {
        // && this.checkOrderType == 1
        this.valExpress = false
        document.getElementById('express').scrollIntoView();
      } else {
        this.loadButton = await false
        var keepdata = []
        var supplierList = []
        var box = null
        var item = []
        this.orders.cartProducts.forEach((e) => {
          item = []
          this.makeBoxList.forEach((i) => {
            if ( i.shopName == e.shopName ) {
              box = i.isMakeBox
            }
          })
          e.cartProductItems.forEach((j) => {
            item.push(j.itemID)
          })
          supplierList.push({
            'isMakeBox': box,
            'itemIDList': item,
            'supplierRemark': this.remark
          })
        })

        var axios = require('axios');
        var data = JSON.stringify({
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "supplierList": supplierList,
          "transportType": this.shipType,
          "orderType": this.checkOrderType,
          "expressCompanyID": this.expressSend.rowId,
          "expressCompanyName": this.express == 11 ? this.otherExpress : this.expressSend.description,
          "receiverAddressID": this.selCusAddress,
          "senderAddressID": this.checkSender == true ? this.selSenderAddress : null
        });
        // if (this.checkOrderType == 1) {
        //   var data = JSON.stringify({
        //     "customerID": JSON.parse(localStorage.getItem('cusId')),
        //     "supplierList": supplierList,
        //     "transportType": this.shipType,
        //     "orderType": this.checkOrderType,
        //     "expressCompanyID": this.expressSend.rowId,
        //     "expressCompanyName": this.express == 11 ? this.otherExpress : this.expressSend.description,
        //     "receiverAddressID": this.selCusAddress,
        //     "senderAddressID": this.checkSender == true ? this.selSenderAddress : null
        //   });
        // } else if (this.checkOrderType == 2) {
        //   var data = JSON.stringify({
        //     "customerID": JSON.parse(localStorage.getItem('cusId')),
        //     "supplierList": supplierList,
        //     "transportType": this.shipType,
        //     "orderType": this.checkOrderType,
        //   });
        // }

        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'app/Cart/send-order',
          headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
          },
          data : data
        };

        await axios(config)
        .then(function (response) {
          keepdata = response.data //success
        })
        .catch(function (error) {
          console.log(error);
        });
        if (keepdata == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'สั่งสินค้าเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          localStorage.removeItem("order_type");
          localStorage.removeItem("list_item");
          localStorage.removeItem("total_quantity");
          localStorage.removeItem("total_yuan");
          localStorage.removeItem("ship_type");
          localStorage.removeItem("makeBox_list");
          this.$router.push({ path: '/customer-orders/detail' });
        }
        this.loadButton = true
      }
    },

    async addCustomerAddress(){
      if (this.nameAddress == '') {
        this.valName = false
      } if(this.telAddress == '') {
        this.valTel = false
      } if(this.address == '') {
        this.valAddress = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/add-customer-address',
          {
            'loginToken': this.userData.data.customerInfo.loginToken,
            'name': this.nameAddress,
            'phone': this.telAddress,
            'address': this.address,
            'tambon': this.selCustomerPostcode.subDistrict,
            'amphoe': this.selCustomerPostcode.district,
            'provinceID': this.selCustomerPostcode.provinceID,
            'province': this.selCustomerPostcode.province,
            'postcode': this.selCustomerPostcode.postcode,
            'postcodeMappingID': this.selCustomerPostcode.rowID,
            'isDefault': this.defaultAddress,
            "isReceiver": true
          },
          { headers: header_token }
        );
        this.nameAddress = ''
        this.telAddress = ''
        this.address = ''
        this.selCustomerPostcode = []
        this.defaultAddress = false
        this.valName = true
        this.valTel = true
        this.valAddress = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'บันทึกที่อยู่ใหม่เรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$refs['customer-address'].hide()
        this.getCusAddress()
      }
    },

    async addSenderAddress(){
      if (this.nameAddress == '') {
        bvModalEvt.preventDefault()
        this.valName = false
      } if(this.telAddress == '') {
        this.valTel = false
      } if(this.address == '') {
        this.valAddress = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/add-sender-address',
          {
            'loginToken': this.userData.data.customerInfo.loginToken,
            'name': this.nameAddress,
            'phone': this.telAddress,
            'address': this.address,
            'tambon': this.selSenderPostcode.subDistrict,
            'amphoe': this.selSenderPostcode.district,
            'provinceID': this.selSenderPostcode.provinceID,
            'province': this.selSenderPostcode.province,
            'postcode': this.selSenderPostcode.postcode,
            'postcodeMappingID': this.selSenderPostcode.rowID,
            'isDefault': true,
            "isReceiver": false
          },
          { headers: header_token }
        );
        this.nameAddress = ''
        this.telAddress = ''
        this.address = ''
        this.selSenderPostcode = []
        this.defaultAddress = false
        this.valName = true
        this.valTel = true
        this.valAddress = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'บันทึกที่อยู่ใหม่เรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.$refs['sender-address'].hide()
        this.getSenderAddress()
      }
    },

    async showImg(img) {
      this.imgLink = await img
      this.$refs['show-img'].show()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
  .myDiv {
    border: 1px outset rgb(255, 255, 255);
  }
  .textVal {
    color: rgb(240, 53, 21);
  }
</style>
